module.exports = __webpack_public_path__ + "static/assets/bbcefdab247665e996d42723b367c6ef.svg";